/** @format */

import React from "react";
import "./AnalysisDetail.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";


import { Line } from "react-chartjs-2";
import insolData from "../../Data/insol_temp_Calc.json";
import tempData from "../../Data/day_avg_temp.json";

const AnalysisDetails = () => {
  const analysisData = [
    {
      title: "Temp Forecast",
      status: "Max",
      value: "17.15",
      trend: "up",
      color: "#ef4444",
    },
    {
      title: "Temp Forecast",
      status: "Min",
      value: "-6.5",
      trend: "down",
      color: "#3b82f6",
    },
    {
      title: "Insol Monthly Avg",
      status: "Avg",
      value: "155.42",
      trend: "stable",
      color: "#f59e0b",
    },
    {
      title: "Precipitation",
      status: "Annual",
      value: "700",
      trend: "up",
      color: "#06b6d4",
    },
    {
      title: "Elevation",
      status: "Height",
      value: "550",
      trend: "stable",
      color: "#84cc16",
    },
    {
      title: "Wind Speed",
      status: "Avg",
      value: "8.7",
      trend: "down",
      color: "#a855f7",
    },
    {
      title: "Humidity",
      status: "Avg",
      value: "65",
      trend: "up",
      color: "#10b981",
    },
  ];

  ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend
  );

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: "bottom",
        },
        title: {
          display: true,
          text: "Monthly Insolation & Temperature - 2025",
        },
      },
    };
  const labels = Array.from({ length: 12 }, (_, i) => `Month ${i + 1}`);

  const data = {
    labels,
    datasets: [
      {
        label: "Avg Insolation (kWh/m²)",
        data: insolData.insol_avg,
        borderColor: "orange",
        fill: false,
      },
      {
        label: "Max Avg Temp (°C)",
        data: insolData.temp_max_avg_monthly + tempData.dailyInsolAvg,
        borderColor: "red",
        fill: false,
      },
    ],
  };

  const getTrendIcon = (trend) => {
    switch (trend) {
      case "up":
        return "↗️";
      case "down":
        return "↘️";
      case "stable":
        return "➡️";
      default:
        return "📊";
    }
  };

  const getTrendColor = (trend) => {
    switch (trend) {
      case "up":
        return "#10b981";
      case "down":
        return "#ef4444";
      case "stable":
        return "#6b7280";
      default:
        return "#6b7280";
    }
  };

  return (
    <div className="analysis-details">
      <div className="details-header">
        <h2>Analysis Details</h2>
        <div className="header-actions">
          <button className="export-btn">📊 Export</button>
          <button className="refresh-btn">🔄 Refresh</button>
        </div>
      </div>

      <div className="details-table">
        <div className="table-header">
          <div className="header-cell">Title</div>
          <div className="header-cell">Status</div>
          <div className="header-cell">Value</div>
          <div className="header-cell">Trend</div>
        </div>

        <div className="table-body">
          {analysisData.map((item, index) => (
            <div key={index} className="table-row">
              <div className="table-cell title-cell">
                <div
                  className="title-indicator"
                  style={{ backgroundColor: item.color }}></div>
                <span className="title-text">{item.title}</span>
              </div>
              <div className="table-cell status-cell">
                <span className={`status-badge ${item.status.toLowerCase()}`}>
                  {item.status}
                </span>
              </div>
              <div className="table-cell value-cell">
                <span className="value-number">{item.value}</span>
              </div>
              <div className="table-cell trend-cell">
                <div
                  className="trend-indicator"
                  style={{ color: getTrendColor(item.trend) }}>
                  <span className="trend-icon">{getTrendIcon(item.trend)}</span>
                  <span className="trend-text">{item.trend}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <br></br>
        <div className="analysis-chart">
          <h3>Insolation & Temperature Analysis</h3>
          <Line data={data} options={options} />
        </div>
      </div>

      <div className="details-footer">
        <div className="last-updated">
          Last updated: {new Date().toLocaleString()}
        </div>
        <div className="data-source">
          Data source: Tamil Nadu Meteorological Department
        </div>
      </div>
    </div>
  );
};

export default AnalysisDetails;
